import { Button, Image, Menu, Tooltip, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { AppDefaults, AuthTypes } from 'config/global-enums';
// import { AppHomeRoutes } from 'modules/Home/routes';
// import { MdArrowDropDown } from 'react-icons/md';
import { StyleConstants } from 'styles/StyleConstants';
import { isMobile } from 'react-device-detect';
// import { selectAuthenticated } from 'modules/Authentication/slice/selectors';
// import { selectTheme } from 'styles/theme/slice/selectors';
// import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { useEffect, useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { ChannelsSubMenuRoutes } from 'modules/Home/routes';

const { Text } = Typography;

const NewWindowLinkWrapper = ({ children, toPath }) => (
  <a
    href={toPath}
    target="_blank"
    rel="noopener noreferrer"
    // style={{ color: customTheme.text, display: 'flex', alignItems: 'center' }}
  >
    {children}
  </a>
);

const productsMenuItems = [
  {
    key: '/products/magics',
    title:
      '<strong>MAGICS</strong> - Multilingual AI-Generated Interactive Customer Service Platform',
    descption: 'Conversational AI for customer services',
    imgSrc: '/images/NavImages/customer-service.png',
  },
  {
    key: '/products/carma',
    title:
      '<strong>CARMA</strong> - Customer Acquisition, Retention, and Management through AI Platform',
    descption: 'Conversational AI for lead generation and sales',
    imgSrc: '/images/NavImages/acquisition.png',
  },
  {
    key: '/products/craft',
    title:
      '<strong>CRAFT</strong> - Channel Partner Resources and Assistance Framework with AI Technology Platform',
    descption: 'Conversational AI for Channel partner services',
    imgSrc: '/images/NavImages/channel-partner.png',
  },
  // {
  //   key: '/products/star',
  //   title: 'Service & Technical Assistance Resource Platform (STAR)',
  //   descption: 'An AI platform that streamlines the tasks of team members.',
  //   imgSrc: '/images/NavImages/service-technical.png',
  // },
  // {
  //   key: '/products/capture',
  //   title:
  //     'Customer Analytics & Predictive Tools for Understanding Retention and Engagement (CAPTURE) Platform',
  //   descption: 'An AI platform to to reduce churn with data-driven insights.',
  //   imgSrc: '/images/NavImages/customer-analytics.png',
  // },
];

const solutionsMenuItems = [
  {
    key: '/solutions/isp',
    title: 'Internet Service Provider (ISP)',
    imgSrc: '/images/NavImages/worldwide.png',
  },
  {
    key: '/solutions/ecommerce',
    title: 'E-commerce',
    imgSrc: '/images/NavImages/online-shopping.png',
  },
  {
    key: '/solutions/websites',
    title: 'Business Websites',
    imgSrc: '/images/NavImages/internet.png',
  },
  {
    key: '/solutions/wordpress',
    title: 'Wordpress',
    imgSrc: '/images/NavImages/wordpress.png',
  },
  {
    key: ChannelsSubMenuRoutes.INSTAGRAM,
    title: 'Instagram',
    imgSrc: '/images/NavImages/IG-messenger.png',
  },
  {
    key: ChannelsSubMenuRoutes.FACEBOOK_MESSENGER,
    title: 'Facebook Messenger',
    imgSrc: '/images/NavImages/FB-messenger.png',
  },
  {
    key: ChannelsSubMenuRoutes.WEB_WIDGET,
    title: 'Web Widget',
    imgSrc: '/images/NavImages/WW-chat.png',
  },
  {
    key: ChannelsSubMenuRoutes.WHATSAPP_BUSINESS_API,
    title: 'WhatsApp Business API',
    imgSrc: '/images/NavImages/WA-whatsapp.png',
  },
];

export const ProductsMegaMenu = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        cursor: 'default',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
        maxWidth: '80vw',
        overflowX: 'scroll',
      }}
    >
      {productsMenuItems.map(menuItem => (
        <div
          key={menuItem.key}
          style={{
            display: 'flex',
            padding: '4px',
            cursor: 'pointer',
            alignItems: 'center',
          }}
          onClick={() => navigate(menuItem.key)}
        >
          <div style={{ marginRight: '10px' }}>
            <img
              src={menuItem.imgSrc}
              alt="ai"
              style={{ width: '24px', height: '24px' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                color: '#000',
                fontSize: '16px',
                lineHeight: '18px',
              }}
              dangerouslySetInnerHTML={{ __html: menuItem.title }}
            />
            <Text
              style={{
                fontSize: '14px',
                lineHeight: '18px',
                color: '#848484',
              }}
            >
              {menuItem?.descption}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export const SolutionsMegaMenu = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        cursor: 'default',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
        maxWidth: '80vw',
        overflowX: 'scroll',
      }}
    >
      {solutionsMenuItems.map(menuItem => (
        <div
          key={menuItem.key}
          style={{
            display: 'flex',
            // flexDirection: 'column',
            padding: '4px',
            cursor: 'pointer',
            alignItems: 'center',
          }}
          onClick={() => navigate(menuItem.key)}
        >
          <div style={{ marginRight: '10px' }}>
            {/* <MdHeadphones size={24} style={{ margin: '10px' }} /> */}
            <img
              src={menuItem.imgSrc}
              alt="ai"
              style={{ width: '24px', height: '24px' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text
              style={{
                fontSize: '16px',
                lineHeight: '18px',
              }}
            >
              {menuItem.title}
            </Text>
            <Text
              style={{
                fontSize: '14px',
                lineHeight: '18px',
                color: '#848484',
              }}
            >
              {menuItem?.descption}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export const navMenuItems = [
  {
    key: '/',
    label: 'Home',
    hideInFooter: true,
  },
  // {
  //   key: '/why-cleandesk-ai',
  //   label: 'Why CleanDesk AI',
  // },
  {
    key: '/products',
    label: 'Products',
    hideInFooter: true,
    children: [
      {
        label: <ProductsMegaMenu />,
        key: '/products/mega-menu',
        style: {
          height: 'fit-content',
          padding: 0,
        },
      },
    ],
  },
  {
    key: '/solutions',
    label: 'Solutions',
    hideInFooter: true,
    children: [
      {
        label: <SolutionsMegaMenu />,
        key: '/solutions/mega-menu',
        style: {
          height: 'fit-content',
          padding: '0px',
        },
      },
    ],
  },
  {
    key: '/pricing',
    label: 'Pricing',
  },
  {
    key: '/integrated-apps',
    label: 'Integrated Apps',
  },
  {
    key: '/about-us',
    label: 'About Us',
  },
  {
    key: '/contact-us',
    label: 'Contact Us',
  },
  {
    key: '/resources',
    label: 'Resources',
    hideInFooter: true,
    children: [
      {
        key: '/documents/developers',
        label: (
          <NewWindowLinkWrapper toPath="https://docs.cleandesk.ai">
            Developers
          </NewWindowLinkWrapper>
        ),
      },
    ],
  },
  {
    key: '/company',
    label: 'Company',
    hideInFooter: true,
    children: [
      {
        key: '/about-us',
        label: 'About',
      },
      {
        key: '/contact-us',
        label: 'Contact Us',
      },
    ],
  },
  {
    key: '/signin',
    label: 'Sign in',
    hideInFooter: true,
  },
  // {
  //   key: '/developers',
  //   label: 'Developers',
  // },
  // {
  //   key: '/resources',
  //   label: 'Resources',
  // },
  // {
  //   key: '/',
  //   label: 'Home',
  //   hideInFooter: true,
  // },
  // {
  //   key: '/contact-us',
  //   label: 'Contact',
  //   openInNew: true,
  // },
  // {
  //   key: '/help-guide',
  //   label: 'Help',
  //   hideInFooter: true,
  //   children: [
  //     {
  //       key: '/help-guide/legislators',
  //       label: (
  //         <LinkWrapper toPath="/help-guide/legislators" disableThemeFont>
  //           Legislators
  //         </LinkWrapper>
  //       ),
  //     },
  //     {
  //       key: '/help-guide/citizens',
  //       label: (
  //         <LinkWrapper toPath="/help-guide/citizens" disableThemeFont>
  //           Citizens
  //         </LinkWrapper>
  //       ),
  //     },
  //   ],
  // },
  // {
  //   key: '/service',
  //   label: 'Service',
  // },
  // {
  //   key: '/help',
  //   label: 'Help',
  // },
];

export default function PublicNavbar(props) {
  const navigate = useNavigate();
  // const isAuthenticated = useSelector(selectAuthenticated);
  // const customTheme = useSelector(selectTheme);
  const location = useLocation();

  const getNavColor = () => {
    switch (location.pathname.slice(1)) {
      case 'about-us':
        return '#ffffff';

      case 'products/craft':
        return '#ffffff';

      case 'products/carma':
        return '#ffffff';

      case 'products/magics':
        return '#ffffff';

      case 'solutions/isp':
        return '#181818';

      case 'solutions/ecommerce':
        return '#ffffff';

      case 'solutions/websites':
        return '#ffffff';

      case 'solutions/wordpress':
        return '#ffffff';

      case 'solutions/channels/instagram':
        return '#FD96A0';

      case 'solutions/channels/whatsapp-business-api':
        return '#258638';

      case 'solutions/channels/facebook-messenger':
        return '#0866FF';

      default:
        return '#181818';
    }
  };

  // const userTypeMenuItems = [
  //   {
  //     key: 'citizenLogin',
  //     label: isMobile ? (
  //       'Citizen'
  //     ) : (
  //       <span style={{ fontWeight: 'bold' }}>LOGIN</span>
  //     ),
  //   },
  //   {
  //     key: AppHomeRoutes.governmentHome,
  //     label: isMobile ? (
  //       'Government'
  //     ) : (
  //       <Button type="primary">For Government</Button>
  //     ),
  //   },
  //   {
  //     key: AppHomeRoutes.legislatorHome,
  //     label: isMobile ? (
  //       'Legislator'
  //     ) : (
  //       <Button type="primary">For Legislator</Button>
  //     ),
  //   },
  //   {
  //     key: AppHomeRoutes.businessHome,
  //     label: isMobile ? (
  //       'Business'
  //     ) : (
  //       <Button type="primary">For Business</Button>
  //     ),
  //   },
  // ];

  const [menuStates, setMenuStates] = useState({
    collapsed: true,
    selectedKey: null,
  });

  useEffect(() => {
    setMenuStates(prevState => ({
      ...prevState,
      selectedKey: navMenuItems
        .map(menuItem => menuItem?.key)
        .filter(el =>
          location.pathname.split('/').filter(Boolean).includes(el),
        )[0],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const findMenuItem = (menuItems, key) => {
    for (const menuItem of menuItems) {
      if (menuItem.key === key) {
        return menuItem;
      }

      if (menuItem.children) {
        const childResult = findMenuItem(menuItem.children, key);
        if (childResult) {
          return childResult;
        }
      }
    }

    return null;
  };

  return (
    <PublicNavbarUI
      id="navbar"
      style={{
        backgroundColor: getNavColor(),
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '4px',
          width: '100%',
        }}
      >
        <Link to="/" aria-label="Go to Home Page">
          <Image
            height={46}
            preview={false}
            style={{ float: 'left', width: 'auto', marginRight: '1rem' }}
            src={'/logo-white.png?x=10000000'}
            alt="company logo"
          />
        </Link>
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginRight: !isMobile && '2rem',
            minWidth: 'fit-content',
          }}
        >
          <Text
            style={{
              color: '#fff',
              // color: customTheme.secondary,
              fontWeight: 600,
              fontSize: '1.4rem',
              lineHeight: 1,
            }}
          >
            {AppDefaults.APP_NAME}
          </Text>
          <Text
            style={{
              margin: '0 0px 0 6px',
              fontSize: 10,
              cursor: 'pointer',
              textAlign: 'right',
              color: '#fff',
            }}
          >
            {/* <Tooltip
              title={
                AppDefaults.APP_BUILD > 0 && `Build(${AppDefaults.APP_BUILD})`
              }
            >
              v{AppDefaults.APP_VERSION}
            </Tooltip> */}
            Beta
          </Text>
        </span>

        <Menu
          style={{
            backgroundColor: 'transparent',
            border: 0,
            color: '#fff',
            justifyContent: 'right',
            overflowY: 'hidden',
          }}
          className="public-navbar-menu"
          mode="horizontal"
          // selectedKeys={menuStates.selectedKey}
          overflowedIndicator={<GiHamburgerMenu style={{ color: '#fff' }} />}
          selectedKeys={[location.pathname]}
          items={navMenuItems.map(menuEl => {
            const { openInNew, hideInFooter, ...rest } = menuEl;
            return { ...rest };
          })}
          onClick={menuItem => {
            // const listItem = navMenuItems.find(
            //   navItem => navItem?.key === menuItem?.key,
            // );
            const listItem = findMenuItem(navMenuItems, menuItem.key);

            // if (listItem) {
            //   listItem?.openInNew
            //     ? window.open(menuItem?.key, '_blank')
            //     : navigate(menuItem?.key);
            // }

            if (listItem) {
              if (
                listItem.key === '/products/mega-menu' ||
                listItem.key === '/solutions/mega-menu' ||
                listItem.key === '/documents/developers'
              ) {
                // Handle special cases, e.g., do nothing
                console.log('Do nothing for mega-menu items');
              } else {
                const { openInNew, ...rest } = listItem;
                if (openInNew) {
                  window.open(rest.key, '_blank');
                } else {
                  navigate(rest.key);
                }
              }
            }
          }}
        />
        {/* <Menu
          style={{
            overflow: 'hidden',
            backgroundColor: 'transparent',
            border: 0,
            color: '#fff',
          }}
          overflowedIndicator={<GiHamburgerMenu />}
          className="public-navbar-menu"
          mode="horizontal"
          // selectedKeys={menuStates.selectedKey}
          selectedKeys={[location.pathname]}
          items={navMenuItems.map(menuEl => {
            const { openInNew, hideInFooter, ...rest } = menuEl;
            return { ...rest };
          })}
          onClick={menuItem => {
            const listItem = navMenuItems.find(
              navItem => navItem?.key === menuItem?.key,
            );
            if (listItem) {
              listItem?.openInNew
                ? window.open(menuItem?.key, '_blank')
                : navigate(menuItem?.key);
            }
          }}
        /> */}
      </div>

      <Button
        style={{ display: 'flex', borderRadius: '8px', margin: '0' }}
        onClick={() => navigate('/signup')}
      >
        Sign up
      </Button>

      {/* {[
        AppHomeRoutes.legislatorHome,
        AppHomeRoutes.governmentHome,
        AppHomeRoutes.businessHome,
      ].includes('/' + location.pathname?.split('/')?.at(-1)) ? (
        !isMobile && ( */}
      {/* <Button
          style={{
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '10px',
            // height: '50px',
            padding: '1.4vw',
            fontSize: '1rem',
          }}
          onClick={() =>
            // navigate(isAuthenticated ? AppDefaults.AUTH_HOME : '/authentication')
            navigate('/contact-us')
          }
        >
          Book A Demo
        </Button> */}

      {/* )
      ) : (
        <Menu
          style={{
            overflow: 'hidden',
            backgroundColor: 'transparent',
            border: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'right',
          }}
          mode="horizontal"
          selectable={false}
          overflowedIndicator={
            <>
              Login as <MdArrowDropDown />
            </>
          }
          items={userTypeMenuItems}
          onClick={menuItem =>
            navigate(
              menuItem.key === 'citizenLogin'
                ? '/authentication'
                : menuItem?.key,
            )
          }
        />
      )} */}
    </PublicNavbarUI>
  );
}

const PublicNavbarUI = styled.header`
  /* box-shadow: 0 1px 0 0 ${p => p.theme.borderLight}; */
  height: ${StyleConstants.NAV_BAR_HEIGHT};
  display: flex;
  position: sticky;
  justify-content: space-between;
  padding: 0px ${isMobile ? '16px' : '50px'};
  align-items: center;
  top: 0;
  width: 100%;
  // background-color: #181818;
  z-index: 2;
  transition: top 0.6s;

  @supports (backdrop-filter: blur(10px)) {
    backdrop-filter: blur(10px);
  }

  .ant-menu > .ant-menu-item:hover,
  .ant-menu > .ant-menu-item-active,
  .ant-menu > .ant-menu-submenu-active,
  .ant-menu > .ant-menu-item-open,
  .ant-menu > .ant-menu-submenu-open,
  .ant-menu > .ant-menu-item-selected,
  .ant-menu > .ant-menu-submenu-selected {
    color: #fff;
    border-bottom: 2px solid #fff;
  }
  .ant-menu-light .ant-menu-submenu-active {
    color: #fff;
  }

  .ant-menu-light .ant-menu-item:hover,
  .ant-menu-light .ant-menu-item-active,
  .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-light .ant-menu-submenu-active,
  .ant-menu-light .ant-menu-submenu-title:hover {
    color: #fff;
  }
  .ant-menu-horizontal > .ant-menu-item::after,
  .ant-menu-horizontal > .ant-menu-submenu::after {
    // position: fixed;
    display: none;
  }

  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
    color: #fff;
  }

  .ant-menu-overflow-item ant-menu-item ant-menu-item-only-child {
    align-items: center;
    display: flex;
  }

  .ant-menu-title-content {
    color: #fff;
  }
`;
